import AddToGroupModal from './AddToGroupModal';

export default AddToGroupModal;
